import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns string with comma
 */

@Pipe({
  standalone: false,
  name: 'stringWithComma'
})
export class StringWithCommaPipe implements PipeTransform {

  /**
	 * Transform
	 *
	 * @param value: string
	 * @param args: number[]
	 */

  transform(value: string, ...args: number[]): string {
    if(args[0] + 1 < args[1]) {
      return value + ',';
    } else {
      return value;
    }
    
  }

}
